// next
import NextLink from 'next/link';
// @mui
import {
  Stack,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';
// hooks
import { PATH_FLIERS } from '../../routes/paths';

// ----------------------------------------------------------------------

const hideScrollbar = {
  msOverflowStyle: 'none',
  scrollbarWidth: 'none',
  overflowX: 'scroll',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
};

export default function FliersTabs({ tab }) {
  return (
    <Stack direction="row" spacing={{ xs: 2, sm: 4 }} sx={{ ...hideScrollbar, pt:3, pb:1 }}>
      <NextLink
        href={`${PATH_FLIERS.root}`}
      >
        <TabItemStyle
          sx={{ minWidth: '100px' }}
          isActive={tab === 'pool'}
        >
          크루 인재풀
        </TabItemStyle>
      </NextLink>
      <NextLink
        href={`${PATH_FLIERS.proposal}`}
      >
        <TabItemStyle
          sx={{ minWidth: '60px' }}
          isActive={tab === 'proposal'}
        >
          커피챗
        </TabItemStyle>
      </NextLink>
      <NextLink
        href={`${PATH_FLIERS.profile}`}
      >
        <TabItemStyle
          sx={{ minWidth: '80px' }}
          isActive={tab === 'profile'}
        >
          회사 정보
        </TabItemStyle>
      </NextLink>
    </Stack>
  )
}

const TabItemStyle = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isActive',
})(({ theme, isActive }) => {
  return {
    ...theme.typography.h4,
    color: theme.palette.text.disabled,
    '&:hover': {
      cursor: 'pointer',
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.background.paper,
    },
    ...(isActive && {
      color: theme.palette.text.primary,
    })
  }
});